import CONFIG from '../../config';

export const AUTH_FINISHED_MESSAGE = 'authenticationFinished';
export const AUTH_CLOSED_MESSAGE = 'authenticationModalClose';

const AUTH_ORIGIN = new URL(CONFIG.authAppUrl).origin;

export type AuthMessage =
  | { type: 'finished'; accessToken: string }
  | { type: 'closed' };

const isAuthFinishedMessage = (
  data: unknown
): data is { name: typeof AUTH_FINISHED_MESSAGE; access_token: string } =>
  !!(
    data &&
    typeof data === 'object' &&
    'name' in data &&
    data.name === AUTH_FINISHED_MESSAGE &&
    'access_token' in data &&
    typeof data.access_token === 'string' &&
    data.access_token
  );

export const parseAuthMessage = ({
  origin,
  data
}: Pick<MessageEvent<unknown>, 'origin' | 'data'>): AuthMessage | null => {
  if (origin !== AUTH_ORIGIN) return null;

  if (isAuthFinishedMessage(data)) {
    return { type: 'finished', accessToken: data.access_token };
  }

  if (data === AUTH_CLOSED_MESSAGE) {
    return { type: 'closed' };
  }

  return null;
};
